import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { CTAButton } from './CTAButton';
export function Volumes() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-258" data-mp="1lx4quf74n18t">
      <div className="mx-auto max-w-4xl" data-id="element-259" data-mp="185q5i1pqynyl">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-260" data-mp="1c5790plm5b14">
          What’s inside DVO Master Protocol™?
        </h2>
        <p className="mt-2 text-center font-display text-lg font-600 uppercase tracking-[0.2em] text-gold-400" data-id="element-261" data-mp="1zt8e1ojl29bs">
          The 6-volume clinical system
        </p>

        <div className="mt-9 space-y-5" data-id="element-262" data-mp="1qtlc91mxz1i7">
          {volumes.map(volume => <article key={volume.number} className="flex flex-col rounded-2xl border border-white/10 bg-navy-950 p-5 sm:p-6" data-id="element-263" data-mp="1vsoeyffg8vn0">
              <p className="font-display text-xs font-700 uppercase tracking-[0.3em] text-gold-500" data-id="element-264" data-mp="keayhvn0zih0">
                {volume.number}
              </p>
              <h3 className="mt-1.5 font-display text-2xl font-700 uppercase leading-tight text-white sm:text-3xl" data-id="element-265" data-mp="3o8yaz2zluppd">
                {volume.title}
              </h3>
              <p className="mt-1.5 text-base font-600 leading-snug text-gold-400" data-id="element-266" data-mp="21hvuhnuztmd">
                {volume.headline}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-267" data-mp="3t5on5f8ah15i">{volume.description}</p>

              <p className="mt-5 text-[11px] font-700 uppercase tracking-[0.18em] text-slate-400" data-id="element-268" data-mp="b026cvj9mwzi">
                Inside you’ll find:
              </p>
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-269" data-mp="kr6k5rx7gbsr">
                {volume.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-270" data-mp="frtpwm4082g5">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-271" data-mp="fupomcnoev5n" />
                    <span className="text-sm leading-snug text-slate-200" data-id="element-272" data-mp="ps43w8xv5dwd">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-auto pt-5 text-sm font-600 text-white" data-id="element-273" data-mp="11skhyv309210">→ {volume.outcome}</p>
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-274" data-mp="16r58g2sgg7c9">
          <CTAButton label="Get the 6-volume system" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-275" data-mp="1bin88niqs1vn" />
        </div>
      </div>
    </section>;
}